import ApiClient from "@/ts/Utility/ApiClient";
import Hint from "@/ts/User/Types/Hint";

export default class HintRepository {
    public static async getAll(): Promise<Hint[]> {
        return await ApiClient.get<Hint[]>('hints');
    }
}
